<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<style lang="sass" scoped>
@import 'component'
</style>

<template lang="pug">

  form(v-on:submit.prevent="onSubmit")

    c-form-error(v-bind:message="$t(responseErrorMessage)")

    div.form-group
      input(autofocus type="password" name="password" v-model="model.password"  v-bind:placeholder="$t('placeholder_enter_the_password')")

    c-form-submit(v-bind:isDisabled="isInvalidRequestParams()" v-bind:isLoading="requestBeingProcessed") {{ $t('btn_sign_in') }}

</template>

<script>
import { minLength, numeric, required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

import * as responseCodes from 'classes/response-codes';
import cFormError from 'components/c-form/c-form-error/component';
import cFormSubmit from 'components/c-form/c-form-submit/component';
import mFormSubmit from 'mixins/formSubmit';
import * as types from 'store/mutation-types';

export default {
  mixins: [mFormSubmit],

  components: {
    cFormError,
    cFormSubmit,
  },

  data() {
    return {
      model: {
        password: null,
        phoneCode: null,
        phoneNumber: null,
        smsCode: null,
      },
    };
  },

  validations: {
    model: {
      password: {
        required,
        minLength: minLength(1),
      },
      phoneCode: {
        required,
        numeric,
        minLength: minLength(1),
      },
      phoneNumber: {
        required,
        numeric,
        minLength: minLength(10),
      },
      smsCode: {
        required,
        numeric,
        minLength: minLength(4),
      },
    },
  },

  computed: {
    ...mapGetters('registration', [
      'phoneCode',
      'phoneNumber',
      'password',
      'smsCode',
      'smsCodeValid',
    ]),
  },

  mounted() {
    this.model.phoneCode = this.phoneCode;
    this.model.phoneNumber = this.phoneNumber;
    this.model.password = this.password;
    this.model.smsCode = this.smsCode;

    if (this.phoneCode && this.phoneNumber && this.password) {
      this.handleSubmit();
    }
  },

  methods: {
    onSubmit() {
      if (this.isInvalidRequestParams()) {
        this.setResponseError('Введите пароль');
        return;
      }
      this.handleSubmit();
    },
    handleRequestUrl() {
      return '/password/check-password';
    },

    handleRequestParams() {
      return {
        phone_code: this.model.phoneCode,
        phone_number: this.model.phoneNumber,
        password: this.model.password,
        security_code: this.model.smsCode,
      };
    },

    handleResponse(response) {
      switch (this.getResponceStatusCode(response)) {
        case responseCodes.RESPONSE_USER_IS_AUTHORIZED:
          this.$store.commit(`registration/${types.SET_PASSWORD}`, null);
          this.$store.commit(`registration/${types.SET_REPEAT_PASSWORD}`, null);

          this.$cookie.set('DSID', response.data.cookie, { expires: '1M', domain: '.deliver.ru' });
          this.$cookie.set('loginCompleted', '1', {
            domain: window.location.hostname.split('.').slice(-2).join('.'),
          });

          window.location = response.data.redirect_url;

          break;
      }
    },
  },
};
</script>
